import React from 'react';
// import { ThemeProvider } from 'next-themes';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import './App.css';
// Only import the theme CSS for the modern approach
import 'ag-grid-community/styles/ag-theme-quartz.css';

import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

// Register AG Grid modules
ModuleRegistry.registerModules([AllCommunityModule]);

import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  Outlet,
  ScrollRestoration,
} from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { Home } from './components/Home/Home';
import { Account } from './components/Account/Account';
import { Pricing } from './components/Pricing';
import { Toaster } from './components/ui/sonner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { InvalidAddress } from './components/Address/InvalidAddress';
import { ChainRouter } from './components/Address/ChainRouter';

import { theme } from './styles/theme';
import { AppProvider } from './hooks/AppProvider';
import { Navbar } from './components/Navbar/Navbar';
import { Register } from './components/Auth/Register';
import { Login } from './components/Auth/Login';
import { ForgotPassword } from './components/Auth/ForgotPassword';
import { ResetPassword } from './components/Account/ResetPassword';
import { TooltipProvider } from './components/ui/tooltip';

// Create a client
const queryClient = new QueryClient();

// Layout component that includes Navbar
const Layout = () => (
  <>
    <Navbar />
    <Outlet />
    <ScrollRestoration />
  </>
);

// Create the router
const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: ':chain/:type/:id',
        element: <ChainRouter />,
      },
      {
        path: ':chain/unknown/:id',
        element: <InvalidAddress />,
      },
      {
        path: 'account',
        element: <Account />,
      },
      {
        path: 'pricing',
        element: <Pricing />,
      },
      {
        path: 'quickstart',
        element: <Home />,
      },
      {
        path: 'register',
        element: <Register />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />,
      },
      {
        path: 'reset-password',
        element: <ResetPassword />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* <ThemeProvider attribute="class" defaultTheme="system" enableSystem> */}
      <ConfigProvider theme={theme}>
        <AppProvider>
          <TooltipProvider>
            <RouterProvider router={router} />
            <Toaster />
          </TooltipProvider>
        </AppProvider>
      </ConfigProvider>
      {/* </ThemeProvider> */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
